var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "margin-top": "15px" } },
    [
      _vm.hmac && _vm.encrypted
        ? _c("iframe", {
            attrs: {
              id: "idFrame",
              name: "nameFrame",
              src: _vm.url,
              frameborder: "0",
              width: "100%",
              height: this.height,
              allowfullscreen: "true",
            },
          })
        : _c("center", [_c("b-spinner")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }